import React, { useState, useEffect, useRef } from 'react';

export default function CustomDropdown({ options, defaultValue, onSelect }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(() => {
    const defaultOption = options.find(opt => opt.value === defaultValue);
    return defaultOption ? defaultOption.label : '';
  });

  const dropdownRef = useRef(null);

  const handleClickOutside = e => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const defaultOption = options.find(opt => opt.value === defaultValue);
    if (defaultOption) {
      setSelected(defaultOption.label);
    }
  }, [options, defaultValue]);

  const handleSelect = option => {
    setSelected(option.label);
    onSelect(option.value);
    setOpen(false);
  };

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="custom-dropdown-selected" onClick={() => setOpen(!open)}>
        {selected}
        <span className="arrow">{open ? <span className="fa-solid fa-angle-up"></span> : <span className="fa-solid fa-angle-down"></span>}</span>
      </div>
      {open && (
        <div className="custom-dropdown-options">
          {options.map(option => (
            <div
              key={option.value}
              className="custom-dropdown-option"
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
